import { Component, input } from '@angular/core';
import { IconChevron } from '../../icons/i-chevron';

@Component({
  selector: 'rid-chevron',
  imports: [IconChevron],
  templateUrl: './rid-chevron.html',
})
export class RidChevron {
  direction = input<'LEFT' | 'RIGHT'>('RIGHT');
}
